import { render, staticRenderFns } from "./InterviewDetail.vue?vue&type=template&id=6c0057a0&"
import script from "./InterviewDetail.vue?vue&type=script&lang=js&"
export * from "./InterviewDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports